// pages/Transactions.js

import Header from "../components/HomeScreen/Header";
import TransactionAdd from "../components/TransactionScreen/TransactionAdd";
import Footer from "../components/HomeScreen/Footer";

const Transactions = () => {
  return (
    <>
      <Header />
      <TransactionAdd />
      <Footer />
    </>
  );
}
export default Transactions;
